import {
	Directive,
	DOCUMENT,
	ElementRef,
	EventEmitter,
	inject,
	Input,
	Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter, fromEvent, Observer, skipUntil, timer } from 'rxjs';

@Directive({
	selector: '[vc-click-outside]',
	standalone: false,
})
export class ClickOutsideDirective {
	private readonly elementRef = inject(ElementRef);
	private readonly _document = inject<Document>(DOCUMENT);

	@Input() excludeFromClosingRegex: RegExp | string | undefined;
	@Output() clickOutside = new EventEmitter<MouseEvent>();

	constructor() {
		fromEvent(this._document, 'click')
			.pipe(
				// Delay as the click to open the dialog might not have been fully captured.
				skipUntil(timer(0)),
				takeUntilDestroyed(),
				filter((event: Event) => {
					if (this.excludeFromClosingRegex) {
						return !!(
							!this.elementRef.nativeElement.contains(
								event.target,
							) &&
							!RegExp(this.excludeFromClosingRegex).exec(
								(event.target as HTMLElement)[
									'className'
								].toString(),
							)
						);
					}
					return !this.elementRef.nativeElement.contains(
						event.target,
					);
				}),
			)
			.subscribe(
				this.clickOutside as unknown as Partial<Observer<Event>>,
			);
	}
}
